import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  max-width: 984px;
  overflow: hidden;
  border-radius: 16px;
  position: relative;
  margin-bottom: 30px;
`;

const AdImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

interface HorizontalAdProps {
    imageUrl: string;
};

export const HorizontalAd: React.FC<HorizontalAdProps> = ({ imageUrl }) => (
  <Wrapper>
    <AdImage src={imageUrl} alt="Реклама" />
  </Wrapper>
);